import styled from 'styled-components'

export const Wrapper = styled.div`
  min-height: 100vh;
`

Wrapper.displayName = 'StyledWrapper'

export const Container = styled.div`
  min-height: 100vh;
`

Container.displayName = 'StyledContainer'
